import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { StarRating } from '../product/StarRating';
import { CarouselControls } from './CarouselControls';
import { useCarousel } from '../../hooks/useCarousel';
import { customerReviews } from '../../data/home';
export function ReviewsSection() {
  const {
    ref,
    canPrev,
    canNext,
    scroll
  } = useCarousel<HTMLUListElement>();
  return <section id="reviews" aria-labelledby="reviews-heading" className="scroll-mt-40 py-14 lg:py-20" data-id="element-165" data-mp="23p6div8dvhvj">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-166" data-mp="1yqmr6tpvo42n">
        <div className="flex items-end justify-between gap-4" data-id="element-167" data-mp="1yr4xkj697yoa">
          <div data-id="element-168" data-mp="1tq8to5lwkciv">
            <h2 id="reviews-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[32px]" data-id="element-169" data-mp="1tpp88ex1n603">
              Klanten aan het woord
            </h2>
            <p className="mt-1.5 flex items-center gap-2 text-[15px] text-muted" data-id="element-170" data-mp="icmtzqif2sj3">
              <StarRating rating={5} data-id="element-171" data-mp="dd0ibli8lkce" />
              <span data-id="element-172" data-mp="dbz6hetecttm">
                <span className="font-semibold text-ink" data-id="element-173" data-mp="dbpbfcthvwh2">4,8</span> gemiddeld uit 6.200+ reviews
              </span>
            </p>
          </div>
          <CarouselControls canPrev={canPrev} canNext={canNext} onPrev={() => scroll(-1)} onNext={() => scroll(1)} label="reviews" data-id="element-174" data-mp="1cp3hexwgwvxg" />
        </div>

        <ul ref={ref} className="-mx-4 mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-4 px-4 pb-2 [scrollbar-width:none] sm:mx-0 sm:scroll-px-0 sm:gap-4 sm:px-0 lg:gap-5 [&::-webkit-scrollbar]:hidden" data-id="element-175" data-mp="xrkpjmohu2ls">
          {customerReviews.map(r => <li key={r.name} className="w-[82%] shrink-0 snap-start sm:w-[calc((100%-1rem)/2)] lg:w-[calc((100%-2.5rem)/3)]" data-id="element-176" data-mp="trajyb4m5e7g">
              <figure className="flex h-full flex-col rounded-2xl border border-line bg-white p-6" data-id="element-177" data-mp="k068vmi26dhw">
                <div className="flex items-center justify-between" data-id="element-178" data-mp="60eql9kieay3">
                  <StarRating rating={5} data-id="element-179" data-mp="63ao4wsg2xm0" />
                  <QuoteIcon className="h-6 w-6 fill-volt text-volt" aria-hidden="true" data-id="element-180" data-mp="a1gnhjqyeaww" />
                </div>
                <h3 className="mt-4 text-base font-bold leading-snug text-ink" data-id="element-181" data-mp="2cpyrhbh2eat7">{r.title}</h3>
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-ink/75" data-id="element-182" data-mp="27xfcqb6n59mt">{r.text}</blockquote>
                <figcaption className="mt-5 border-t border-line pt-4 text-sm" data-id="element-183" data-mp="2305eq756rpnd">
                  <span className="block font-semibold text-ink" data-id="element-184" data-mp="1y1c2sj5js6pb">{r.name}</span>
                  <span className="block text-xs text-muted" data-id="element-185" data-mp="2vokvay3yug0t">{r.product}</span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}